//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import TimeField from '../fields/TimeField.vue'
import SelectField from '../fields/SelectField.vue';
import InputField from '../fields/InputField.vue';
import axios from 'axios';
export default {
  components: {
    TimeField,
    SelectField,
    InputField,
  },
  props: {
    availability: Number,
    ajax: String,
    sessions: Array | null,
  },
  data: function(){
    return {
      type: 'groepssessie',
      seq_id: '',
      session: {
        value: '',
        error: '',
      },
      start: {
        value: '00:00',
        error: '',
      },
      end: {
        value: '00:00',
        error: '',
      },
    };
  },
  methods: {
    handleDelete: function(){
      if(!this.seq_id){
        this.handleActionDelete('only');
        return;
      }
      const self = this;
      $.confirm({
        theme: 'bootstrap',
        title: 'Verwijderen',
        content: 'Dit beschikbaarheid is gemaakt in een herhaling. Welke wil je verwijderen?',
        boxWidth: '500px',
        useBootstrap: false,
        buttons: {
          future: {
            text: 'Huidige en toekomstige',
            btnClass: 'btn btn-secondary',
            action: function(){
              self.handleActionDelete('only_future')
            },
          },
          only: {
            text: 'Huidige',
            btnClass: 'btn btn-primary',
            action: function(){
              self.handleActionDelete('only')
            },
          },
        },
      });
    },
    handleSave: function(){
      if(!this.seq_id){
        this.handleActionSave('only');
        return;
      }
      const self = this;
      $.confirm({
        theme: 'bootstrap',
        title: 'Updaten',
        content: 'Dit beschikbaarheid is gemaakt in een herhaling. Welke wil je updaten?',
        boxWidth: '500px',
        useBootstrap: false,
        buttons: {
          future: {
            text: 'Huidige en toekomstige',
            btnClass: 'btn btn-secondary',
            action: function(){
              self.handleActionSave('only_future')
            },
          },
          only: {
            text: 'Huidige',
            btnClass: 'btn btn-primary',
            action: function(){
              self.handleActionSave('only')
            },
          },
        },
      });
    },
    handleActionSave: function(close){
      const formData = new FormData();
      formData.append('close', close);
      formData.append('availability', this.availability);
      formData.append('session', this.session.value.code);
      formData.append('start', this.start.value);
      formData.append('end', this.end.value);
      axios({
        method: 'post',
        url: `${this.ajax}?action=update_availability`,
        data: formData,
        headers: {
          'Content-type': 'application/json',
        },
      }).then(() => {
        this.$parent.handleSuccess();
        this.$parent.handleEditClose();
        this.$parent.success = true;
      }).catch(() => {
        console.log('error');
      });
    },
    handleActionDelete: function(close){
      const formData = new FormData();
      formData.append('close', close);
      formData.append('availability', this.availability);
      axios({
        method: 'post',
        url: `${this.ajax}?action=delete_availability`,
        data: formData,
        headers: {
          'Content-type': 'application/json',
        },
      }).then(() => {
        this.$parent.handleSuccess();
        this.$parent.handleEditClose();
        this.$parent.success = true;
      }).catch(() => {
        console.log('error');
      });
    },
    handleClose: function(){
      this.$parent.handleEditClose();
    },
  },
  mounted: function(){
    const formData = new FormData();
    formData.append('id', this.availability);
    axios({
        method: 'post',
        url: `${this.ajax}?action=get_availability`,
        data: formData,
        headers: {
          'Content-type': 'application/json',
        },
      }).then(response => {
        const data = response.data;
        this.seq_id = data.seq_id;
        this.type = data.type;
        this.start.value = data.start;
        this.end.value = data.end;
        if (data.session) {
          this.session.value = {
            label: data.session.title,
            code: data.session.id,
          };
        }
      }).catch(() => {
        console.log('error');
      });
  },
}



// WEBPACK FOOTER //
// ./scripts/vue/Agenda/EditDate.vue